import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { ContactPerson } from '../../cmsPageState'
import { ContactPersonBlock } from '../blocksState'
import { ContactPersonBlockLayout } from './contactPersonBlockLayout'
import { ContactPersonBlockState } from './contactPersonBlockState'

export const contactPersonBlockWidget = (
  block: ContactPersonBlock
): Widget<Updater<ContactPersonBlockState>> =>
  async<ContactPerson>(block.contactPersonBlockState, contactPerson =>
    fromJSX(() => (
      <ContactPersonBlockLayout
        index={block.index}
        inview={block.inview}
        contactPerson={contactPerson}
      />
    ))
  )
